import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DataMapResult, DataMapStructure } from '../data/data-maps/data-map';

@Injectable({ providedIn: 'root' })
export class TranslationsService {
  public constructor(private translationsService: TranslateService) {}

  public translateCommaSeperatedString(string: string, group: string): string {
    if (!string) {
      return string;
    }

    const courses = string.split(',').map((value) => {
      return this.translate(`${group}.${value.trim()}`, value);
    });

    return courses.join(', ');
  }

  public translate(key: string, fallback: string | number | null): any {
    let value;
    const translatedReason = this.translationsService.instant(key);

    if (translatedReason !== key) {
      value = translatedReason;
    } else {
      value = fallback;
    }

    return value;
  }

  public getDataMapValue(dataMap: DataMapStructure, key: string | null): string {
    const config = dataMap[key];

    if (!config) {
      return key;
    }

    return this.translate(config.key, key);
  }

  public translateDataMap(dataMap: DataMapStructure): DataMapResult {
    const translatedData = {};

    for (const key in dataMap) {
      const translationData = dataMap[key];
      translatedData[key] = this.translate(translationData.key, translationData.fallback ?? null);
    }

    return translatedData;
  }
}
